export default __webpack_public_path__ + "static/media/nova.842181cc.jfif";